import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface Props {
    entityPathNames: ?(string[]);
}

export class SharedEventEntityPathNames extends React.PureComponent<Props> {
    render() {
        const { entityPathNames } = this.props;
        if (!entityPathNames) return null;
        return entityPathNames.join(' / ');
    }
}

const mapStateToProps = createStructuredSelector({
    entityPathNames: makeSelectSharedEventValue('entityPathNames')
});

export default connect(mapStateToProps)(SharedEventEntityPathNames);
